import React from "react";

const CareerObjective = () => {
  return (
    <div className="mt-20 container mx-auto px-5">
      <div className="text-left ">
        <h2 className="text-2xl font-bold text-sweet_red mb-3">Career objective</h2>
        <p className="text-lg ">
          I am highly interested in web development and I anticipate using my
          skill to develop And maintain professional quality websites.
        </p>
      </div>
    </div>
  );
};

export default CareerObjective;
